<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container">
      <router-link to="/" class="navbar-brand"><img src="@/assets/logo.png" alt="AEDIL" width="150"></router-link>
      <div class="collapse navbar-collapse" id="adel-nav">
        <div class="navbar-nav">
          <router-link to="/" class="nav-item nav-link">Home</router-link>
          <router-link to="/about" class="nav-item nav-link">About Us</router-link>
          <div class="nav-item dropdown" @mouseover="openDropdown" @mouseleave="closeDropdown">
            <a class="nav-link dropdown-toggle" href="#" role="button" :class="{ 'show': dropdownOpen }" @click.prevent="toggleDropdown">
              Product
            </a>
            <div class="dropdown-menu" :class="{ 'show': dropdownOpen }" @mouseover="openDropdown" @mouseleave="closeDropdown">
              <router-link to="/bwx" class="dropdown-item">BattleWiki-X</router-link>
              <router-link to="/munus" class="dropdown-item">Munus</router-link>
            </div>
          </div>
          <router-link to="/contact" class="nav-item nav-link">Contact Us</router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Navigation',
  data() {
    return {
      dropdownOpen: false
    };
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    openDropdown() {
      this.dropdownOpen = true;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    }
  }
};
</script>
